"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BriarBulwarkEffectHandler = exports.BriarBulwarkEffectArgs = void 0;
const _1 = require(".");
const Damage_1 = require("../../Damage");
const Duration_1 = require("../../Duration");
const enums_1 = require("../../enums");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class BriarBulwarkEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.BriarBulwark;
        this.__typeName = "BriarBulwark";
        this.name = "Briar Bulwark";
        this.harmful = false;
    }
}
exports.BriarBulwarkEffectArgs = BriarBulwarkEffectArgs;
let BriarBulwarkEffectHandler = class BriarBulwarkEffectHandler {
    apply(sequence, container, state) {
        const targetLevel = container.getLevel(state.targetId);
        const [focus, will] = container.getAttributeScores(state.creatorId, [
            enums_1.AttributeType.Focus,
            enums_1.AttributeType.Will
        ]);
        state.meta.effectIds = container.applyBuffs({
            sequence,
            creatorId: state.creatorId,
            targetId: state.targetId,
            effects: [
                {
                    effect: new _1.DamageReciprocateEffectArgs(new Damage_1.Damage(enums_1.DamageType.Nature, focus + will)),
                    duration: Duration_1.Duration.Permanent,
                }
            ]
        });
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        for (const effectId of state.meta.effectIds) {
            container.cancelEffect(sequence, effectId);
        }
    }
};
BriarBulwarkEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.BriarBulwark)
], BriarBulwarkEffectHandler);
exports.BriarBulwarkEffectHandler = BriarBulwarkEffectHandler;
